import { CellText, StyledEyeIcon } from "assets/js/Styles";
import React from "react";
import { RotateCcw } from "react-feather";
import { UncontrolledTooltip } from "reactstrap";
import { genericPost } from "services/services.general";
import styled from "styled-components";
import Swal from "sweetalert2";
import { getFormattedDateString, Toast } from "utility/helpers";

const StyledResendIcon = styled(RotateCcw)`
  color: ${({ theme }) => theme.colors.iconBlue};
`;

const handleResendClicked = (row) => {
  Swal.fire({
    title: "Warning",
    text: `Are you sure you want to resend #${row.id}`,
    icon: "warning",
    confirmButtonText: "OK",
    showCancelButton: true,
  }).then((result) => {
    if (result.isConfirmed) {
      genericPost({
        url: "/logs/resend-sms",
        formData: {
          notificationIds: row.id.toString(),
        },
        callback: ({ isSuccess }) => {
          if (isSuccess) {
            Toast({
              type: 1,
              content: "Successfully resend sms.",
            });

            window.location.reload();
          } else {
            Toast({
              type: 4,
              content: "An error occurred.",
            });
          }
        },
      });
    }
  });
};

const logColumns = ({ agencies, handleViewModal }) => {
  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      style: { paddingLeft: 0, paddingRight: 0 },
      cell: () => null,
    },
    {
      name: "Notif #",
      selector: ({ id }) => id,
      sortable: true,
      minWidth: "150px",
      cell: ({ id }) => <CellText>{id}</CellText>,
    },
    {
      name: "Allocation #",
      selector: ({ logInfo }) => logInfo?.allocationId,
      sortable: true,
      minWidth: "150px",
      cell: ({ logInfo }) => <CellText>{logInfo?.allocationId}</CellText>,
    },
    {
      name: "Recipient Name",
      selector: ({ logInfo }) => logInfo?.recipient,
      sortable: true,
      minWidth: "200px",
      cell: ({ logInfo }) => <CellText>{logInfo?.recipient}</CellText>,
    },
    {
      name: "Recipient Contact",
      selector: ({ to }) => to,
      sortable: true,
      minWidth: "130px",
      cell: ({ to }) => <CellText>{to}</CellText>,
    },
    {
      name: "Agency",
      selector: ({ logInfo }) => logInfo?.agency,
      sortable: true,
      minWidth: "100px",
      cell: ({ logInfo }) => {
        const agency = agencies?.find((ag) => ag.name === logInfo.agency);

        return <CellText>{agency?.acronym}</CellText>;
      },
    },
    {
      name: "Amount",
      selector: ({ logInfo }) => logInfo?.amount,
      sortable: true,
      minWidth: "180px",
      cell: ({ logInfo }) => <CellText>{logInfo?.amount}</CellText>,
    },
    {
      name: "Region",
      selector: ({ logInfo }) => logInfo?.region,
      sortable: true,
      minWidth: "200px",
      cell: ({ logInfo }) => (
        <CellText>{logInfo?.region?.name ?? logInfo?.region}</CellText>
      ),
    },
    {
      name: "Date Sent",
      selector: null,
      sortable: false,
      minWidth: "150px",
      cell: ({ sentAt }) => (
        <CellText>
          {getFormattedDateString(sentAt, "MMM dd, yyyy HH:mm")}
        </CellText>
      ),
    },
    {
      name: "Actions",
      selector: null,
      sortable: false,
      cell: (row) => {
        return (
          <>
            <StyledEyeIcon
              size={16}
              onClick={() => handleViewModal(row)}
              id={`view-row--${row.id}`}
            />
            <UncontrolledTooltip
              placement="left"
              target={`view-row--${row.id}`}
            >
              {"View"}
            </UncontrolledTooltip>

            <StyledResendIcon
              size={16}
              onClick={() => handleResendClicked(row)}
              id={`resend-row--${row.id}`}
            />
            <UncontrolledTooltip
              placement="right"
              target={`resend-row--${row.id}`}
            >
              {"Resend"}
            </UncontrolledTooltip>
          </>
        );
      },
    },
  ];
};

export default logColumns;
